/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

import { Renderer, Builder } from "./common";
const baseClassName = styleNames.base;
const componentClassName = 'form-builder';

/**
 * This is the component description.
 */
const FormBuilder = ({
  id,
  className: userClassName,
  style,
  mode,
  formData,
  readOnly,
  shouldSubmit,
  formBuilderId,
  onBuilderFormSave,
  onBuilderError,
  onRendererFormSave,
  onFileUpload,
  onBuilderValidate,
  initialBuilderValues,
  fileUploadStatus,
  handleFileDelete,
  taskData
  // ...otherProps
}) => {
  const formattedJson = JSON.stringify(taskData, null, 2);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
    // {...otherProps}
  }, taskData && /*#__PURE__*/React.createElement("pre", {
    className: "task-data md-span-12 span-8 s-1"
  }, formattedJson), mode === 'build' && /*#__PURE__*/React.createElement(Builder, {
    initialValues: initialBuilderValues,
    formBuilderId: formBuilderId,
    onSave: onBuilderFormSave,
    onError: onBuilderError,
    validate: onBuilderValidate
  }), mode === 'render' && /*#__PURE__*/React.createElement(Renderer, {
    formData: formData,
    onSave: onRendererFormSave,
    readOnly: readOnly,
    shouldSubmit: shouldSubmit,
    fileUploadStatus: fileUploadStatus,
    handleFileDelete: handleFileDelete,
    onFileUpload: onFileUpload
  }));
};
FormBuilder.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The mode of the form builder to determine whether to render a form or build a form
   */
  mode: PropTypes.oneOf(['build', 'render']),
  /**
   * This is the ID of the form element in the <Builder /> component
   */
  formBuilderId: PropTypes.string.isRequired,
  /**
   *  The form data to be used to construct the form builder in renderer mode
   */
  formData: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
  }),
  /**
   *  The initial values to instatiate form builder in builder mode
   */
  initialBuilderValues: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
  }),
  /**
   * Whether the whole Form in renderer mode should be readOnly
   */
  readOnly: PropTypes.bool,
  /**
   * Whether the form builder in renderer mode should submit the form values itself
   */
  shouldSubmit: PropTypes.bool,
  /**
   * The upload status of files if any
   */
  fileUploadStatus: PropTypes.objectOf(PropTypes.string),
  /**
   * The task preview data
   */
  // eslint-disable-next-line react/forbid-prop-types
  taskData: PropTypes.objectOf(PropTypes.any)
};
FormBuilder.defaultProps = {
  mode: 'build',
  readOnly: false
};
FormBuilder.Builder = Builder;
FormBuilder.Renderer = Renderer;
export default FormBuilder;